import {scrollToBottom} from "../../sources/js/functions/helpers";

(function () {
    const btn = document.querySelector('.relinking__title-btn');
    const block = document.querySelector('.relinking__list');

    if (btn && block) {
        btn.addEventListener('click', e => {
            e.preventDefault();

            e.currentTarget.classList.toggle('relinking__title-btn_close');

            block.classList.toggle('relinking__list_close');
            scrollToBottom();
        })
    }
}());
